import * as React from "react";
import Snackbar from '@mui/material/Snackbar';

function SimpleSnackbar({
  open,
  text,
  handleClose,
  autoHideDuration = 3000,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      message={text}
    >
  </Snackbar>
  );
}


export default SimpleSnackbar;
